<template>
  <Modal
    open
    persistent
    :title="props.hub.congratulationsPopupHeadline"
    :description="props.hub.congratulationsPopupBody"
    :hide-cancel="!hasCtaButton"
    :confirm-label="
      hasCtaButton
        ? props.hub.congratulationsPopupCtaButtonText
        : t('common.close')
    "
    @cancel="redirectToHub"
    @confirm="onConfirm"
  >
    <template #icon>
      <Icon :name="IconName.CUP" :size="IconSize['4XL']" class="text-success" />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Icon, IconName, IconSize } from '@exfluential/ui';
import { apiMarkHubCompletionModalAsDisplayed, HubDto } from '~/api/hubs';
import { useLoader } from '~/composables/use-loader';
import { useHubStore } from '~/store/hub';

type Props = {
  hub: HubDto;
};
const props = defineProps<Props>();

const { t } = useI18n();

const { refreshHub } = useHubStore();

const hasCtaButton = computed(
  () =>
    props.hub.displayCongratulationsPopupCtaButton &&
    Boolean(props.hub.congratulationsPopupCtaButtonUrl),
);

const redirectToHub = () => {
  navigateTo(`/${props.hub.slug}`);
};

const onConfirm = () => {
  if (hasCtaButton.value && props.hub.congratulationsPopupCtaButtonUrl) {
    window.open(props.hub.congratulationsPopupCtaButtonUrl, '_blank');
  }
  redirectToHub();
};

onMounted(async () => {
  await useLoader({
    async action() {
      await apiMarkHubCompletionModalAsDisplayed(props.hub.slug);
      await refreshHub();
    },
  });
});
</script>
